import { OperationContext } from '../../../../../common/operations/enums/OperationContext';
import { OperationType } from '../../../../../common/operations/enums/OperationType';
import { Key } from './valueObjects/Key';

export class Operation {
  constructor(
    private readonly id: number,
    private readonly context: OperationContext,
    private readonly type: OperationType,
    private readonly algorithms: string[],
    private readonly keys: Key[]
  ) {}

  getId() {
    return this.id;
  }

  getContext() {
    return this.context;
  }

  getType() {
    return this.type;
  }

  getAlgorithms() {
    return this.algorithms;
  }

  getKeys() {
    return this.keys;
  }
}
